<template>
    <div>
        <div class="slice-option_address">
            <div class="flex justify-between items-center">
                <label class="label whitespace-no-wrap flex items-center">Return Address <span class="opacity-50 mr-2 ml-1"> (Unit, House
                        Number, Street, City, State)</span>
                    <el-tooltip
                        content="Provide a valid return address. If the item is returned, you will be responsible for return shipping costs to this address"
                        placement="top">
                        <span>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M8.8 5.6H7.2V4H8.8V5.6ZM8.8 12H7.2V7.2H8.8V12ZM8 0C6.94943 0 5.90914 0.206926 4.93853 0.608964C3.96793 1.011 3.08601 1.60028 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.08601 14.3997 3.96793 14.989 4.93853 15.391C5.90914 15.7931 6.94943 16 8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 6.94943 15.7931 5.90914 15.391 4.93853C14.989 3.96793 14.3997 3.08601 13.6569 2.34315C12.914 1.60028 12.0321 1.011 11.0615 0.608964C10.0909 0.206926 9.05058 0 8 0Z"
                                    fill="#383F51" />
                            </svg>
                        </span>
                    </el-tooltip>
                </label>
            </div>
            <auto-complete :customStyle="customStyle" :locationDetails="viewLocationDetails" placeholder="Enter Address"
                :value="address.name" />
        </div>
    </div>
</template>

<script>
export default {
    name: "ReturnAddress",
    data() {
        return {
            addressType: "",
            address: {
                name: "",
                lat: null,
                lng: null
            },
        }
    },
    computed: {
        customStyle() {
            return {
                width: '100%',
                padding: '7px 10px',
                borderRadius: '5px',
                border: '1px solid rgb(183 189 205)'
            }
        },
    },
    methods: {
        viewLocationDetails(response) {
            const addressData = {
                name: response.formatted_address,
                lat: response.geometry.location.lat(),
                lng: response.geometry.location.lng()
            }
            this.address = addressData
        },
    },
}
</script>

<style lang="scss" scoped>
.slice-option_address {
    @apply mt-4 w-full;
}
</style>